import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { BrComponent } from '@bloomreach/react-sdk';
import { generateConditionalClassNames } from '../utils/utils.js';

var CmsRowColumn = ({ component  })=>{
    const _ref = component.getParameters(), { showInDesktop , showInTablet , showInPhone , fullWidth  } = _ref, cssStyles = swcHelpers.objectWithoutProperties(_ref, [
        "showInDesktop",
        "showInTablet",
        "showInPhone",
        "fullWidth"
    ]);
    const filteredStyles = Object.fromEntries(Object.entries(cssStyles).filter(([_, value])=>value !== ''
    ));
    const columnClassName = generateConditionalClassNames('br-column', {
        showInDesktop,
        showInTablet,
        showInPhone
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: columnClassName,
        "data-t": "br-column",
        style: swcHelpers.objectSpread({}, filteredStyles)
    }, /*#__PURE__*/ React.createElement(BrComponent, null));
};

export { CmsRowColumn, CmsRowColumn as default };
//# sourceMappingURL=RowColumn.js.map
